<nz-select [(ngModel)]="value" (ngModelChange)="handleValueChange($event)">
  @for (deepgramVoice of getDeepgramVoiceList(); track $index) {
    <nz-option [nzValue]="deepgramVoice.id" [nzLabel]="getLabel(deepgramVoice)"></nz-option>
  }
</nz-select>
